export const NORDHEALTH_PAY_RESOURCE_TYPES = {
  AGGREGATION: 'nordhealth_pay_aggregation',
  FILTERS: 'nordhealth_pay_filters',
  PAYMENT: 'nordhealth_pay_payment',
} as const

export const NORDHEALTH_PAY_REPORT_COLUMNS = {
  AccountDescription: {
    id: 'account_description',
    accessorKey: 'attributes.account_description',
  },
  Actions: {
    id: 'actions',
    accessorKey: undefined,
  },
  CardLastFour: {
    id: 'card_last_four',
    accessorKey: 'attributes.card_last_four',
  },
  Client: {
    id: 'client',
    accessorKey: 'attributes.client',
  },
  Currency: {
    id: 'currency',
    accessorKey: 'attributes.currency',
  },
  Fees: {
    id: 'fees',
    accessorKey: 'attributes.total_fee',
  },
  Net: {
    id: 'net',
    accessorKey: 'attributes.net_amount',
  },
  NordhealthFee: {
    id: 'nordhealth_fee',
    accessorKey: 'attributes.nordhealth_fee',
  },
  OtherFees: {
    id: 'other_fees',
    accessorKey: 'attributes.other_fees',
  },
  PaidOut: {
    id: 'paid_out',
    accessorKey: 'attributes.paid_out',
  },
  PaymentAmount: {
    id: 'payment_amount',
    accessorKey: 'attributes.payment_amount',
  },
  PaymentDate: {
    id: 'payment_date',
    accessorKey: 'attributes.payment_date',
  },
  PaymentMethod: {
    id: 'payment_method',
    accessorKey: 'attributes.payment_method',
  },
  PaymentType: {
    id: 'payment_type',
    accessorKey: 'attributes.payment_type',
  },
  PayoutDate: {
    id: 'payout_date',
    accessorKey: 'attributes.payout_date',
  },
  PspReference: {
    id: 'psp_reference',
    accessorKey: 'attributes.psp_reference',
  },
  RefundAmount: {
    id: 'refund_amount',
    accessorKey: 'attributes.refund_amount',
  },
  RelatedInvoice: {
    id: 'related_invoice',
    accessorKey: 'attributes.related_invoice',
  },
  Status: {
    id: 'status',
    accessorKey: 'attributes.status',
  },
  Terminal: {
    id: 'terminal',
    accessorKey: 'attributes.terminal',
  },
  TransactionId: {
    id: 'transaction_id',
    accessorKey: 'attributes.transaction_id',
  },
} as const

export const NORDHEALTH_PAY_ENDPOINTS = {
  AGGREGATIONS: '/v2/reporting/nordhealth-pay/payments/aggregations',
  FILTERS: '/v2/reporting/nordhealth-pay/payments/filters',
  LIST: '/v2/reporting/nordhealth-pay/payments',
} as const
